import { register } from 'register-service-worker'; // The ready(), registered(), cached(), updatefound() and updated()
// events passes a ServiceWorkerRegistration instance in their arguments.
// ServiceWorkerRegistration: https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerRegistration

register(process.env.SERVICE_WORKER_FILE, {
  // The registrationOptions object will be passed as the second argument
  // to ServiceWorkerContainer.register()
  // https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/register#Parameter
  // registrationOptions: { scope: './' },
  ready: function ready() {
    if (process.env.DEV) {
      console.log('App is being served from cache by a service worker.');
    }
  },
  registered: function registered()
  /* registration */
  {
    if (process.env.DEV) {
      console.log('Service worker has been registered.');
    }
  },
  cached: function cached()
  /* registration */
  {
    if (process.env.DEV) {
      console.log('Content has been cached for offline use.');
    }
  },
  updatefound: function updatefound()
  /* registration */
  {
    if (process.env.DEV) {
      console.log('New content is downloading.');
    }
  },
  updated: function updated()
  /* registration */
  {
    if (process.env.DEV) {
      console.log('New content is available; please refresh.');
    }
  },
  offline: function offline() {
    if (process.env.DEV) {
      console.log('No internet connection found. App is running in offline mode.');
    }
  },
  error: function error(err) {
    if (process.env.DEV) {
      console.error('Error during service worker registration:', err);
    }
  }
});